import { render } from "./ClientConfiguracionPermisos.vue?vue&type=template&id=738f8c45"
import script from "./ClientConfiguracionPermisos.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionPermisos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__